<template>
  <el-dialog :title="$t('AccountManagement.staffLeave.records')" :visible.sync="visible" width="95%" top="5vh">
    <el-alert v-if="loadFailed" :title="$t('AccountManagement.staffLeave.loadFailed')" type="error" :closable="false" show-icon />
    <el-table v-loading="loading" class="leave-table" :data="pageRecords" border stripe max-height="560" :empty-text="$t('AccountManagement.staffLeave.empty')">
      <el-table-column
        v-for="column in columns"
        :key="column.prop"
        :prop="column.prop"
        :label="$t('AccountManagement.staffLeave.' + column.prop)"
        :min-width="column.weight"
      />
    </el-table>
    <el-pagination
      class="leave-pagination"
      :current-page.sync="page"
      :page-size="pageSize"
      :page-sizes="[20, 50, 100]"
      :total="records.length"
      layout="total, sizes, prev, pager, next"
      @size-change="changePageSize"
    />
    <div slot="footer">
      <el-button :loading="loading" @click="fetchRecords">{{ $t('AccountManagement.staffLeave.refresh') }}</el-button>
      <el-button @click="visible = false">{{ $t('AccountManagement.work.close') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { funConfigApi } from '@/api';

export default {
  name: 'StaffLeaveDialog',
  data() {
    return {
      visible: false,
      loading: false,
      loadFailed: false,
      records: [],
      page: 1,
      pageSize: 20,
      columns: [
        // Small min-width values act as proportional weights within the available width.
        { prop: 'createPerson', weight: 7 },
        { prop: 'createPersonDept', weight: 8 },
        { prop: 'type', weight: 7 },
        { prop: 'startTime', weight: 9 },
        { prop: 'endTime', weight: 9 },
        { prop: 'leaveHours', weight: 7 },
        { prop: 'noPayLeave', weight: 7 },
        { prop: 'duration', weight: 7 },
        { prop: 'approveResult', weight: 8 },
        { prop: 'approveStatus', weight: 8 },
        { prop: 'leaveReason', weight: 12 },
        { prop: 'createTime', weight: 9 },
      ],
    };
  },
  computed: {
    pageRecords() {
      const start = (this.page - 1) * this.pageSize;
      return this.records.slice(start, start + this.pageSize);
    },
  },
  methods: {
    open() {
      this.visible = true;
      this.fetchRecords();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.page = 1;
    },
    async fetchRecords() {
      if (this.loading) return;
      this.loading = true;
      this.loadFailed = false;
      this.records = [];
      this.page = 1;
      try {
        const response = await funConfigApi.getWorkforceStaffLeaveList();
        if (!Array.isArray(response)) {
          this.loadFailed = true;
          return;
        }
        // API dates use yyyy-MM-dd HH:mm:ss, so lexical order is chronological.
        // Missing creation times sort last without relying on browser date parsing.
        this.records = response.filter(record => record && typeof record === 'object').slice().sort((a, b) => {
          const left = a.createTime || '';
          const right = b.createTime || '';
          return left === right ? 0 : left < right ? 1 : -1;
        });
      } catch (error) {
        this.loadFailed = true;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.leave-table {
  width: 100%;
}
.leave-table ::v-deep .cell {
  padding: 0 6px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.leave-pagination {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
}
</style>
